import ServiceLayout from "../components/ServiceLayout";

export default function ITSupport(){
  return(
    <ServiceLayout
      title="IT Support & Maintenance"
      subtitle="Reliable technical support that never sleeps."
      gradient="linear-gradient(135deg,#ff9966,#ff5e62)"
      features={[
        "24/7 Monitoring",
        "Backup Solutions",
        "System Updates",
        "Security Checks",
        "Troubleshooting",
        "Performance Optimization"
      ]}
    />
  );
}
